/**
 * MagliaSquadra — mini-maglia di una squadra, pescata da useSquadre.
 * Da affiancare al nome squadra in classifica / dashboard / rose.
 */

import { useSquadre } from "../../hooks/useFase7";
import { Maglia } from "./Maglia";

export function MagliaSquadra({
  squadraId,
  size = 22,
  className = "",
}: {
  squadraId: string;
  size?: number;
  className?: string;
}) {
  const { data: squadre } = useSquadre();
  const s = squadre?.find((x) => x.id === squadraId);
  if (!s) return null;
  return (
    <Maglia
      pattern={s.maglia_pattern}
      coloreCorpo={s.maglia_colore_corpo}
      coloreDettaglio={s.maglia_colore_dettaglio}
      coloreManiche={s.maglia_colore_maniche}
      coloreAccento={s.maglia_colore_accento}
      coloreColletto={s.maglia_colore_colletto}
      colorePolsini={s.maglia_colore_polsini}
      coloreSponsor={s.maglia_colore_sponsor}
      sponsor={s.maglia_sponsor}
      patchScudetto={s.maglia_patch_scudetto}
      patchChampions={s.maglia_patch_champions}
      logoDataUrl={s.logo_data_url}
      size={size}
      className={`shrink-0 ${className}`}
    />
  );
}
